import { render, staticRenderFns } from "./captain_bonus_owner_types.vue?vue&type=template&id=453b5258&scoped=true&"
import script from "./captain_bonus_owner_types.vue?vue&type=script&lang=js&"
export * from "./captain_bonus_owner_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b5258",
  null
  
)

export default component.exports